import { useEffect, useState } from 'react';

/** Значення, що оновлюється лише після паузи у змінах (для серверного пошуку в Select). */
export function useDebouncedValue<T>(mdValue: T, mdDelayMs = 300): T {
  const [mdDebounced, setMdDebounced] = useState(mdValue);

  useEffect(() => {
    const mdTimer = setTimeout(() => setMdDebounced(mdValue), mdDelayMs);
    return () => clearTimeout(mdTimer);
  }, [mdValue, mdDelayMs]);

  return mdDebounced;
}
